import { format } from 'date-fns';
import { cs, de, enGB, es, fr, it, nl, pl, ru } from 'date-fns/locale';
import { useSelector } from 'react-redux';
import { selectSystemLanguage } from '../redux/modules/data/localizationSlice';

const useFormatLocaleDate = (date) => {
	const systemLanguage = useSelector((state) => selectSystemLanguage(state));
	const locales = {
		cz: cs, de, en: enGB, es, fr, it, nl, pl, ru,
	};

	let formattedLocalDate = '';
	if (date) {
		formattedLocalDate = format(date, 'P', { locale: locales[systemLanguage] });
	}

	return formattedLocalDate;
};

export default useFormatLocaleDate;
